import React from 'react';
import loadable from '@loadable/component';
import LoadingComponent from 'components/LoadingComponent';


export default loadable(() => import('../layout/NotFound'), {
	fallback: <LoadingComponent />
});
